<template>
  <div class="contentbox">
    <div class="conten">
      <ul class="equipment_management" :class="show_search_state?'show_search':''">
        <li class="header_search" :class="show_search_state?'show_search':''">
          <div class="search_input_box">
            <div>
              <el-input size="mini" v-model="key_word" placeholder="关键字"></el-input>
            </div>
            <div>
              <el-button size="mini" @click="onseach" type="success">查詢</el-button>
            </div>
          </div>
          <i class="el-icon-arrow-down" @click="showsearchbox"></i>
        </li>
        <li class="header_list" :class="show_search_state?'show_search':''">
          <div>型號</div>
          <div>產品名稱</div>
          <div>編號</div>
          <div>SKU No</div>
          <div>產品類別</div>
          <div>類別編號</div>
          <div>單位兌換比例</div>
          <div>補貨</div>
          <div>庫存</div>
          <div>最低存货量</div>
          <div>留貨數</div>
          <div>點數有效期</div>
          <div>最近出庫日期</div>
          <div>CBM</div>
          <div>已購買總數</div>
          <div>已使用總數</div>
          <div>最近購買日期</div>
          <!--<div>未出數量</div>-->
          <!--<div>可銷售數量</div>-->
          <!--<div>未入數量</div>-->
          <!--<div>未暫入</div>-->
          <!--<div>未暫出</div>-->
          <!--<div>未退入</div>-->
          <!--<div>未退出</div>-->
        </li>
        <li v-for="(itme,index) in inventory_list" :key="index">
          <div v-html="itme.product_name"></div>
          <div>{{itme.product_code}}</div>
          <div>{{itme.product_model}}</div>
          <div>{{itme.product_code_manual}}</div>

          <div>
            <span v-html="itme.category_name"></span><span v-if="itme.category_name_two">,</span>
            <span v-html="itme.category_name_two"></span><span v-if="itme.category_name_three">,</span>
            <span v-html="itme.category_name_three"></span><span v-if="itme.category_name_four">,</span>
            <span v-html="itme.category_name_four"></span>
          </div>
          <div>
            {{itme.category_remark}}<span v-if="itme.category_remark_two">,</span>
            {{itme.category_remark_two}}<span v-if="itme.category_remark_three">,</span>
            {{itme.category_remark_three}}<span v-if="itme.category_remark_four">,</span>
            {{itme.category_remark_four}}</div>
          <div>
            {{itme.product_pcs_num}}
            <span v-if="itme.product_pcs_num && itme.product_ctn_num">:</span>
            {{itme.product_ctn_num}}
            {{itme.unit_ctn}}
          </div>

          <div>{{itme.stock_status === '1' ? '是':'否'}}</div>
          <div>{{itme.product_qty}}</div>
          <div>{{itme.stock_num}}</div>
          <div>{{itme.stay_goods_number}}</div>

          <div>{{itme.end_date}}</div>
          <div>{{itme.out_date}}</div>
          <div>{{itme.cbm_sum_total}}</div>
          <div>{{itme.storage_count}}</div>
          <div>{{itme.outgoing_count}}</div>
          <div>{{itme.create_time}}</div>
          <!--<div>{{itme.not_out}}</div>-->
          <!--<div>{{itme.can_sale_number}}</div>-->
          <!--<div>{{itme.not_in}}</div>-->
          <!--<div>{{itme.z_not_in}}</div>-->
          <!--<div>{{itme.not_out}}</div>-->
          <!--<div>{{itme.t_not_in}}</div>-->
          <!--<div>{{itme.not_out}}</div>-->


          <!--<div>-->
            <!--<el-input v-model="itme.product_remark"-->
                      <!--@keyup.enter.native="edit(itme.product_id,itme.product_remark)"-->
                      <!--placeholder="请输入内容">-->
            <!--</el-input>-->
          <!--</div>-->
        </li>
      </ul>
      <div class="bottom_but">
        <div></div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          background
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import {MessageBox, Button, Toast} from 'mint-ui';
  import {
    inventory_index,
    saveProductRemark,
  } from '../../assets/js/api'

  export default {
    name: "orderlist",
    data() {
      return {
        show_search_state: false, //設備列表
        inventory_list: [], //設備列表
        key_word: '',//关键字
        currentPage: 1,//當前頁數
        total: 0,//數據總數
      }
    },
    components: {
      MessageBox,
      Button,
      Toast,
    },
    mounted() {
      this.currentPage = Number(this.$route.query.currentPage) || 1

      this.onseach()

    },
    methods: {
      edit(id,remark){
        let p_data={
          product_id:id,
          remark:remark,
        }
        saveProductRemark(p_data).then(data=>{
          this.$alert(data.message, '提示', {
            confirmButtonText: '确定',
            callback: action => {
            }
          });
        })
      },
      onseach(){
        let p_data={
          key_search:this.key_word,
          page:this.currentPage,
        }
        inventory_index(p_data).then(data => {
          if (data.status) {
            this.inventory_list = data.data
            this.total = Number(data.pageCount)
          }
          else {
            this.inventory_list = []
            this.total = 0
          }
        })
      },
      showsearchbox() {
        if (this.show_search_state) {
          this.show_search_state = false
        }
        else {
          this.show_search_state = true
        }
      },
      //切換列表
      handleCurrentChange(val) {
        this.currentPage = val
        this.onseach()
      },
    },
    destroyed() {//离开该页面需要移除这个监听的事件
      window.removeEventListener('scroll', this.handleScroll)
    }
    ,
  }
</script>

<style lang="less" scoped>
  @import "../../assets/less/base";

  html, body, #app {
    height: 100%;
  }


  .contentbox {
    background-color: #f2f2f2;
    width: 100%;
    .signature_box {
      backgrond: #fff;
      width: 80vw;
      padding-top: 10%;
      text-align: center;
      @media (min-width: @screen-xs-max) {
        width: 40vw;
      }
      .itme_box{
        margin-bottom: 20px;
        position: relative;
        .itme{
          display: flex;
          align-items: center;
          justify-content: flex-start;
          margin-bottom: 5px;
          >.name{
            width: 30%;
            text-align: left;
            flex-shrink: 0;
          }
          .customer_num{
            width: 28%;
          }
          .right20{
            margin-right: 10px;
          }
        }
        .icon{
          position: absolute;
          right: -30px;
          bottom: 10px;
          cursor: pointer;
        }
      }
      .paymentmethodbut {
        display: flex;
        justify-items: center;
        justify-content: center;
        .mint-button {
          /*margin-right: 20px;*/
          margin: 0 10px;
          cursor: pointer;
        }
      }
    }
    .conten {
      margin-top: 52px;
      ul.equipment_management  {
       background: #fff;
        padding-bottom: 1px;
        /*min-height: 96vh;*/
        margin-top: 52px;
        padding-top: 104px;
        transition: all 0.5s;
        &.show_search{
          padding-top: 140px;
        }
        li {
          background-color: #f2f2f2;
          margin: 10px 0;
          width: 96%;
          padding: 10px 2%;
          display: flex;
          /*flex-direction: column;*/
          align-items: center;
          justify-content: space-around;
          > div {
            width: 12%;
            min-width: 5%;
            text-align: center;
            cursor: pointer;
            word-wrap: break-word;
            .modify_tag{
              border-bottom: 1px #000 dotted;
              display: inline-block;
              padding: 5px;
              min-width: 50%;
            }
          }
          &.white {
            background: white;
          }
          &.header_list {
            position: fixed;
            background-color: #57c5f7;
            padding: 20px 2%;
            margin: 0;
            z-index: 9;
            top: 80px;
            border-bottom: 1px solid #b7bbbf;
            color: #fff;
            transition: all 0.5s;
            &.show_search{
              top: 112px;
            }
            > div {
              font-size: 15px;
              font-weight: bold;
            }
          }
          &.header_search {
            width: 100%;
            position: fixed;
            flex-direction: column;
            justify-items: center;
            background-color: #327594;
            margin: 0;
            padding: 10px 0;
            z-index: 9;
            top: 52px;
            border-bottom: 1px solid #b7bbbf;
            color: #fff;
            transition: all 0.5s;
            height: 10px;
            .search_input_box{
              display: none;
              width: 90%;
              cursor: auto;
              >div{
                margin: 0 20px;
              }
            }
            &.show_search{
              height: 50px;
              .search_input_box{
                display: flex;
                align-items: center;
                justify-content: center;
              }
              >i{
                transform: rotate(180deg);
              }
            }
            > i {
              transition: all 0.5s;
              font-size: 20px;
              font-weight: bold;
              cursor: pointer;
            }
          }
        }
      }
      .bottom_but {
        position: fixed;
        width: 96%;
        padding: 0 2%;
        display: flex;
        justify-content: space-between;
        bottom: 30px;
        a{
          color: #fff;
        }
      }
      .add_order_but {
        position: fixed;
        bottom: 80px;
        right: 2%;
        cursor: pointer;
        i {
          color: #67C23A;
          font-size: 48px;
        }
      }
      .add_order_but {
        position: fixed;
        bottom: 80px;
        right: 2%;
        cursor: pointer;
        i {
          color: #67C23A;
          font-size: 48px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/orderlist_child/point.vue